import { State } from '../../@types';

export const getAuthSelector = (state: State) => state.auth;
export const getAuthToken = () => localStorage.getItem('token');
export const getUserSelector = (state: State) => getAuthSelector(state)?.user;
